export const connectionErrorMessage = '¡Tenemos problemas de conexión con el servidor, intente mas tarde.!';